export function getQueryParamsFromUrl() {
  const queryParams = Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  );
  //   console.log("queryParams", queryParams);
  return queryParams;
}

export function getFirstBrowserLanguage() {
  const lang = navigator.language || (navigator as { userLanguage?: string }).userLanguage;
  return lang;
}

const DEV_HOSTS = ["localhost", "local.apptonomy.ai", "lan.apptonomy.ai"];
const STAGING_HOSTS = ["www-staging.apptonomy.ai"];
/** SBX-03: the Sandbox webapp host. Sandbox has staging-equivalent access. */
const SANDBOX_HOSTS = ["www-sandbox.apptonomy.ai"];
const PROD_HOSTS = ["www.apptonomy.ai"];

const _hostname =
  typeof window !== "undefined" ? window.location.hostname : "";
const hostNameIsIpAddress = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(_hostname);

export const isDevHost =
  hostNameIsIpAddress || DEV_HOSTS.includes(_hostname);
export const isStagingHost = STAGING_HOSTS.includes(_hostname);
export const isSandboxHost = SANDBOX_HOSTS.includes(_hostname);
export const isProdHost = PROD_HOSTS.includes(_hostname);

/**
 * Single source of truth for "should this dev/staff-only surface be visible?"
 *
 * Returns true when:
 * - Running on a dev host (localhost / local.apptonomy.ai / lan.apptonomy.ai)
 * - Running on the staging host (www-staging.apptonomy.ai)
 * - Running on the Sandbox host (www-sandbox.apptonomy.ai) — Sandbox has
 *   staging-equivalent access (SBX-03)
 * - Query param `?devui=true` is present (escape hatch for ad-hoc prod
 *   debugging)
 *
 * Prefer the `useDevUI()` hook in React components — that wraps this and
 * memoizes the result. This function exists for non-React callers.
 */
export function shouldShowDevUI(): boolean {
  if (isDevHost || isStagingHost || isSandboxHost) return true;
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get("devui") === "true";
}


// MARK: User Agent
// export const isSafari =
//   /^Safari/.test(navigator.vendor) &&
//   /Safari/.test(navigator.userAgent) &&
//   !/Chrome|CriOS|FxiOS|EdgiOS|OPR|Edg/.test(navigator.userAgent);

// export const isChrome =
//   /Chrome/.test(navigator.userAgent) &&
//   !/Edg|OPR|Brave|SamsungBrowser/.test(navigator.userAgent);

// export const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
// export const isAndroid = /Android/i.test(navigator.userAgent);
// export const isMobile = isIos || isAndroid;
// export const isDesktop = !isAndroid && !isIos;

// export function getCurrentOS() {
//   const userAgent = navigator.userAgent.toLowerCase();
//   if (userAgent.includes("mac")) return "macos";
//   if (userAgent.includes("windows")) return "windows";
//   if (userAgent.includes("linux")) return "linux";
//   if (isAndroid) return "android";
//   if (isIos) return "ios";
//   return "unknown";
// }

// export const isEmbeddedInWebview = () => {
//   const userAgent = navigator.userAgent.toLowerCase();
//   if (isAndroid && userAgent.includes("; wv")) return "android_webview";
//   // if (userAgent.includes("gsa/")) return "gsa"; // Google Search App
//   if (userAgent.includes("instagram")) return "instagram";
//   if (userAgent.includes("fbav")) return "facebook";
//   if (userAgent.includes("fban")) return "facebook";
//   if (userAgent.includes("twitter")) return "twitter";
//   if (userAgent.includes("tiktok")) return "tiktok";
//   if (userAgent.includes("line")) return "line";
//   if (userAgent.includes("linkedin")) return "linkedin";
//   if (userAgent.includes("whatsapp")) return "whatsapp";
//   if (userAgent.includes("snapchat")) return "snapchat";
//   if (userAgent.includes("pinterest")) return "pinterest";
//   if (userAgent.includes("telegram")) return "telegram";
//   if (userAgent.includes("micromessenger")) return "wechat"; // WeChat
//   return null;
// };
